import { useLocation, Link as RouterLink } from 'react-router-dom';
import { AppRoutes } from '@consts/routes';
import { Breadcrumbs, Link } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

/**
 * This is a map of routes to breadcrumb labels.
 * If a route is not in this map, it will not be displayed in the breadcrumb.
 */
const BREADCRUMB_LABELS: Record<string, string> = {
    [AppRoutes.SystemManagement]: 'Manage RapidCut Systems',
    [AppRoutes.ManageCompany]: 'Manage Company',
    [AppRoutes.ManageReseller]: 'Manage Reseller',
    [AppRoutes.ManageLocation]: 'Manage Location',
    [AppRoutes.ManageSystem]: 'Manage System',
    [AppRoutes.Activity]: 'Cut Activity',
    [AppRoutes.Insights]: 'Insights',
    [AppRoutes.Models]: 'Manage Models',
    [AppRoutes.Design]: 'Manage Design',
    [AppRoutes.ManageUser]: 'Manage User',
    [AppRoutes.Users]: 'Manage Users',
    [AppRoutes.CutHistory]: 'Cut History',
    [AppRoutes.Organizations]: 'Manage Organizations',
    [AppRoutes.BatchProcessing]: 'Batch Processing',
    [AppRoutes.Invoices]: 'Invoice Management',
    [AppRoutes.Employees]: 'Employee Ranks',
    [AppRoutes.EmployeeDetails]: 'Employee Details',
};

export const RouteBreadcrumb = () => {
    const location = useLocation();

    const routes = location.pathname.split('/');

    return location.pathname !== AppRoutes.Insights ? (
        <Breadcrumbs sx={{ marginRight: '20px', color: 'white' }}>
            <Link component={RouterLink} to={AppRoutes.Insights} color={'white'}>
                <HomeIcon fontSize={'small'} sx={{ marginTop: '5px' }} />
            </Link>

            {routes.map((route, idx) => {
                const completeRoute = routes.slice(0, idx + 1).join('/');

                const label = BREADCRUMB_LABELS[completeRoute];

                const routeExists = Object.values(AppRoutes).includes(completeRoute as AppRoutes);

                return (
                    route &&
                    routeExists &&
                    label && (
                        <Link component={RouterLink} underline='none' key={route} color={'white'} to={completeRoute}>
                            {idx === routes.length - 1 ? <b>{label}</b> : label}
                        </Link>
                    )
                );
            })}
        </Breadcrumbs>
    ) : null;
};
